interface CenteredScrollInput {
    scrollLeft: number
    scrollWidth: number
    viewportWidth: number
    itemLeft: number
    itemWidth: number
}

export function centeredScrollLeft(input: CenteredScrollInput) {
    const target = input.scrollLeft + input.itemLeft - (input.viewportWidth - input.itemWidth) / 2
    return Math.max(0, Math.min(target, Math.max(0, input.scrollWidth - input.viewportWidth)))
}
